import React, { useContext, useState, useRef } from 'react';
import gsap from 'gsap';
import Flip from '../gsap/Flip.min.js';
gsap.registerPlugin(Flip);

import { useApiContext } from "../context/ApiContext.jsx";
import { AuthContext } from "../context/AuthContext.jsx";

const MAX_NICKNAME_LEN = 15;

const NickNameSelector = () => {
	const { api, isDemo } = useApiContext();
	const { sessionInfo, setSessionInfo } = useContext(AuthContext);
	const cardRef = useRef(null);

	// meglio stringa vuota: eviti null-check ovunque
	const [nickname, setNickname] = useState('');

	const handleNicknameChange = (ev) => {
		// taglia a MAX_NICKNAME_LEN (copypaste incluso)
		const value = (ev.target.value ?? '').slice(0, MAX_NICKNAME_LEN);
		setNickname(value);
	};

	const submitNickname = () => {
		const nick = nickname.trim();

		// guardrail: non chiamare API se nick non valido
		if (nick.length < 2 || nick.length > MAX_NICKNAME_LEN) return;

		if (isDemo) {
			setSessionInfo(prev => ({ ...(prev ?? {}), nickName: nick }));
			return;
		}

		api.post(`/api/trivia/set-session-nickname?nickname=${encodeURIComponent(nick)}`)
			.then((response) => {
				console.log(response.data);
				setSessionInfo(response.data);
			});
	};

	const nickLen = nickname.length;
	const nickValid = nickname.trim().length >= 2 && nickLen <= MAX_NICKNAME_LEN;

	return (
		<div className="container animate__animated animate__fadeIn" id="nickname-selector">
			<div className="row">
				<div className="col">
					{sessionInfo.template?.mascotNormalMediaId ? (
						<img
							className="mascotte d-block"
							src={`/api/trivia/media/${sessionInfo.template.mascotNormalMediaId}`}
							style={{ height: 165 }}
							alt=""
						/>
					) : ""}

					<h1 className="fw-bold text-center lh-1 splash-title">
						{sessionInfo.title || sessionInfo.roomName}
					</h1>
					<h2
						className="splash-description mb-3 text-center w-lg-50 mx-auto"
						dangerouslySetInnerHTML={{ __html: sessionInfo.description }}
					/>

					<h3 className="mb-3 text-center">
						<small className="d-block fs-3 mt-4">Per prima cosa...</small>
						<span className="fw-bold">scegli il tuo nickname!</span>
					</h3>

					<form onSubmit={(ev) => { ev.preventDefault(); submitNickname(); }}>
						<input
							type="text"
							className="form-control form-control-lg mx-auto d-block"
							style={{ maxWidth: "400px" }}
							placeholder="Inserisci il tuo nickname"
							value={nickname}
							onChange={handleNicknameChange}
							maxLength={MAX_NICKNAME_LEN}
						/>

						{/* micro-UX: contatore caratteri */}
						<div className="text-center mt-2">
							<small className={nickLen >= MAX_NICKNAME_LEN ? "text-danger" : "text-muted"}>
								{nickLen}/{MAX_NICKNAME_LEN}
							</small>
						</div>

						<div className="text-center mt-3">
							<a
								onClick={(ev) => { ev.preventDefault(); submitNickname(); }}
								href="#"
								style={{ width: "fit-content" }}
								className={`btn btn-primary btn-lg mt-5 d-flex mx-auto align-items-center ${!nickValid ? "disabled" : ""}`}
							>
								Conferma e continua
							</a>
						</div>
					</form>

				</div>
			</div>
		</div>
	);
};

export default NickNameSelector;